<template>
    <a-icon :component="PhoneSVG" />
</template>
<script>
import PhoneSVG from './svgs/PhoneSVG'
export default {
    name : 'PhoneIcon',
    components : {
        PhoneSVG
    },
    data() {
        return {
            PhoneSVG
        }
    }

}
</script>